import { LayoutGrid, LayoutGridItem } from '@cko/primitives';
import styled from 'styled-components';

export const StyledLayoutGrid = styled(LayoutGrid)`
  min-width: 100%;
  height: 100%;
  grid-template-rows: 60px auto;
  grid-gap: 0;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 60px);
  position: fixed;
  top: 60px;
  left 0;
  width: 100vw;
  overflow-anchor: none;
  scroll-margin-top: 60px;
`;

export const ContentArea = styled.main`
  flex: 1 1 100%;
  overflow: auto;
  overflow-anchor: none;
  scroll-margin-top: 60px;
`;

export const StyledLayoutGridItem = styled(LayoutGridItem)`
  overflow: hidden;
`;
